export * from './diagonal.model';
export { createDiagonal } from './diagonal.creator';
